import PrivateVehiclesScene from './scenes/PrivateVehiclesScene';

const routes = [
  {
    path: '/vehicles',
    component: PrivateVehiclesScene,
    exact: false,
    menuName: 'myVehicles',
    menuIcon: 'truck',
    hasRight: 'organisations/read/vehicles',
  },
];

export default routes;
